export interface IRoleGroup{
    description: string;
    id: number;
    name: string;
    rolesCount: number;
}